export const REGION = "asia-southeast1";
// local
export const LOCAL_USER = "Local User";
// ref

export const API_BANKS = "https://api.vietqr.io/v2/banks";
